import { applicationsTranslations } from "modules/applications";
import { bankAccountsTranslations } from "modules/bank-accounts";
import { cashManagementTranslations } from "modules/cash-management";
import { checkoutTranslations } from "modules/checkout";
import {
  circuitBreakerOldTranslations,
  circuitBreakerTranslations,
} from "modules/circuit-breaker";
import { customerTranslations } from "modules/customers";
import { dashboardTranslations } from "modules/dashboard";
import { payoutsTranslations } from "modules/payouts";
import { transactionsTranslations } from "modules/transactions";
import { userManagementTranslations } from "modules/user-management";
import { userSettingsTranslations } from "modules/user-settings";

import accounts from "./accounts";
import cashManagement from "./cashManagement";
import { common } from "./common";
import { countries } from "./countries";
import currencies from "./currencies";
import customers from "./customers";
import customersCheckoutBranding from "./customersCheckoutBranding";
import errors from "./errors";
import transactions from "./transactions";

const index = {
  accounts,
  applications: applicationsTranslations.enGb,
  bankAccounts: bankAccountsTranslations.enGb,
  circuitBreaker: Object.assign(
    circuitBreakerOldTranslations,
    circuitBreakerTranslations
  ),
  cashManagement: Object.assign(
    cashManagement,
    cashManagementTranslations.enGb
  ),
  checkout: checkoutTranslations.enGb,
  common,
  countries,
  currencies,
  customers: Object.assign(customers, customerTranslations.enGb),
  customersCheckoutBranding,
  dashboard: dashboardTranslations.enGb,
  errors,
  transactions: Object.assign(transactions, transactionsTranslations.enGb),
  payouts: Object.assign(payoutsTranslations.enGb),
  users: userManagementTranslations.enGb,
  userSettings: userSettingsTranslations.enGb,
};

export default index;
